export const koehlerFirmLogo = require("./KoehlerFirmLogo.png");